


































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class HumptyDumptyCard extends Vue {
  @Prop({ default: () => ({}) }) value!: any;

  localVal: any = this.initVal();

  initVal() {
    return {
      umur: 1, jenis_kelamin: 1, diagnosis: 1,
      gangguan_kognitif: 1, faktor_lingkungan: 1,
      respons_operasi: 1, penggunaan_obat: 1,
      skor_total: 7, kategori: 'rendah',
      intervensi: {
        bel_mudah_dijangkau: false, roda_terkunci: false,
        posisi_terendah: false, pagar_dinaikkan: false,
        reasesmen_1x24jam: false, tanda_risiko_jatuh: false,
        edukasi_keluarga: false, intervensi_a_lainnya: '',
        dekat_nurse_station: false, reasesmen_2x_per_shift: false,
        intervensi_b_lainnya: '',
      },
      ...(this.value || {})
    };
  }

  @Watch('value', { deep: true })
  onValueChange() {
    this.localVal = this.initVal();
  }

  recalculate() {
    const v = this.localVal;
    v.skor_total = (v.umur || 1) + (v.jenis_kelamin || 1) + (v.diagnosis || 1)
      + (v.gangguan_kognitif || 1) + (v.faktor_lingkungan || 1)
      + (v.respons_operasi || 1) + (v.penggunaan_obat || 1);
    v.kategori = v.skor_total >= 12 ? 'tinggi' : 'rendah';
    this.$emit('input', { ...v });
  }
}
